import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from './Icon';

const IconWithText = ({ size, iconRight, children, ...rest }) => {
  const iconClass = classNames(`icon-with-text icon-with-text--${size}`, {
    'icon-with-text--left': !iconRight,
    'icon-with-text--right': iconRight,
  });

  return (
    <div className={iconClass}>
      <Icon size={size} {...rest} />
      {children}
    </div>
  );
};

IconWithText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]).isRequired,
  size: PropTypes.string,
  iconRight: PropTypes.bool,
};

export default IconWithText;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/IconWithText.js